export { assertPageFilePath };
import { assert, isNpmPackageModule, assertPosixPath } from './utils';
function assertPageFilePath(filePath) {
    assertPosixPath(filePath);
    assert(filePath.startsWith('/') || isNpmPackageModule(filePath), { filePath });
}
